// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2xFhu","form":"styles_form__2coMz"};